import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a6ff440"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-10 pt-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("登记")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("加班管理")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "上传前请先确定日期", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "日期:表示结余假期的时间，如10月结余的假期填11月的某一天", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("结余详情")
const _hoisted_9 = { class: "mb-10" }
const _hoisted_10 = { class: "descriptionsTop" }
const _hoisted_11 = { class: "descriptionsTop" }
const _hoisted_12 = { class: "descriptionsTop" }
const _hoisted_13 = { class: "descriptionsTop" }
const _hoisted_14 = { class: "descriptionsTop" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("调休假剩余 ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("(鼠标移动查看详情) ")
const _hoisted_18 = { class: "descriptionsTop" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("日期代表当前月的月底过期，当月加班系统会自动延期一个月")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("换薪中")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_22 = { class: "pt-10 pb-10" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("延期")

import { ref, Ref, reactive, onBeforeMount, computed } from 'vue'
import tbMix from '@/global_mixin/tableMixin'
import eptBtn from '@/components/ExportButton.vue'
import dayjs from 'dayjs'
import Api from '@/http/modules/index'
import { ElMessage, ElMessageBox } from 'element-plus';
import store from '@/store/index'
import { categoryType,overtimeNatureType} from '@/views/typeMapping/AttendanceMap'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  // 根据条件获取假期余额人员列表
  'POST/checkin_balances/user/list': fetchList,
  // 根据用户id或日期范围获取假期历史明细
  'POST/checkin_balances/user/history': checkinDeatils,
  'GET/users/list': userListApi,
  // 加班换薪修改(更新年假加班假)
  'PATCH/checkin_balances': checkin_balancesModifyApi,
  // 删除年假加班假
  'DELETE/checkin_balances/{id}': checkin_balancesDelApi,
  // 获取所有公司
  'GET/company': companyApi,
  // 获取所有团队
  'GET/organizations': organizationsApi,
  // 登记
  'POST/checkin_balances': checkin_balancesApi,
  // 加班管理列表
  'POST/checkin_balances/overtime/list': overtimeListApi,
  // 加班延期
  'PATCH/checkin_balances/batch': checkin_balancesBatchApi,
  // 下载年假加班调休假导入模板
  'GET/checkin_balances/template': templateDownloadApi,
  // 导入年假加班调休假模板
  'POST/checkin_balances/import': importCheckin_balancesApi,
  // 假期余额导出
  'POST/checkin_balances/export': exportcheckin_balancesApi,
} = Api

const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

let fullUserList: any = ref([])

onBeforeMount(() => {
  userListApi().then((_userList: object[]) => {
    fullUserList.value = _userList.map((_user: any) => {
      _user.label = `${_user.realName}(${_user.alias})`
      return _user
    })
  })
})

const searchConfig = ref([
  { 
    label: '姓名',
    value: '',
    upKey: 'key',
    props: {}
  },
  {
    type: "TIME",
    label: "日期",
    value: [],
    upKey: '_date',
    upProps: { includeKey: 'dateRange' },
    props: {
      type: 'daterange',
      'value-format': 'YYYY-MM-DD',
      clearable: true,
    }
  },
  {
    type: 'SELECT',
    selectType: 'GROUP',
    label: '公司',
    value: '',
    upKey: 'companyIds',
    options: store.getters.sysCompany,
    props: { clearable: true, multiple: true, 'collapse-tags': true, style: 'width: 350px', placeholder: '请选择公司'},
    seleProps: {label: 'name', valueName: 'id'}
  },
  {
    type: 'SELECT',
    label: '团队',
    value: '',
    upKey: 'orgId',
    options: store.getters.sysOrganizations,
    props: {clearable: true, placeholder: '请选择团队'},
    seleProps: {label: 'name', valueName: 'id'}
  },

])
const searchHandle = async (params: any) => {
  await fetchData(params)
  if(MI_tableData.value.length === 1){
    detailsHandle(MI_tableData.value[0])
  }

}

const {
  MI_tableData: detailsData, fetchData: detailsFetch, page: detailsPage, size: detailsSize, MI_params: detailsParams,
  MI_total: detailsTotal, MI_pageChange: detailsPageCg, MI_identify: detailsIdentify, MI_sizeChange: detailsSizeCg
} = new tbMix(checkinDeatils)
// 详情
let detailsRow: any = reactive({})
const detailsHandle = async (row: any) => {
  let { detail } = await detailsFetch({ 
    userId: row.userId, 
    dateRange: MI_params.dateRange,
  })
  Object.assign(detailsRow, detail)
  
}
// 详情修改
const detailsModifyFg = ref<boolean>(false)
const categoryParams: any = {
  AnnualIncrease: {operate: true, category: 'Annual'},
  AnnualReduce: {operate: false, category: 'Annual'},
  OverTimeIncrease: {operate: true, category: 'OverTime'},
  OverTimeReduce: {operate: false, category: 'OverTime'},
}
const detailsModifyConfig = ref([
  /* {
    type: 'NUMBER',
    value: '',
    label: '增加小时',
    upKey: 'time',
    rule: [
      { required: true, message: '增加小时不能为空', trigger: 'change' },
    ],
    props: { clearable: true, }
  } */
  {
    type: "TIME",
    label: "日期",
    value: '',
    upKey: 'date',
    rule: [
      { required: true, message: '日期不能为空', trigger: 'change' },
    ],
    props: {
      'value-format': 'YYYY-MM-DD',
      clearable: true,
    }
  },
  {
    label: "小时",
    value: '',
    upKey: 'time',
    rule: [
      { required: true, message: '小时不能为空', trigger: 'change' },
    ],
  },
  {
    type: 'SELECT',
    label: '类别',
    value: '',
    upKey: 'category',
    rule: [
      { required: true, message: '类别不能为空', trigger: 'change' },
    ],
    options: [
      {label: '年假增加', id: 'AnnualIncrease'},
      {label: '年假减少', id: 'AnnualReduce'},
      {label: '加班增加', id: 'OverTimeIncrease'},
      {label: '加班减少', id: 'OverTimeReduce'},
    ],
    props: { placeholder: '请选择类别', clearable: true },
    seleProps: {}
  },
  {
    label: '事由',
    value: '',
    upKey: 'note',
    props: { type: 'textarea'}
  },
])
const detailsModifyHandle = (row: any) => {
  let category = ''
  // 判断类别
  if(row.category === 'Annual'){
    category = row.operate ? 'AnnualIncrease' : 'AnnualReduce'
  } else {
    category = row.operate ? 'OverTimeIncrease' : 'OverTimeReduce'
  }
  MI_modifyForm(row, detailsModifyConfig, detailsModifyFg, async (params: any) => {
    await checkin_balancesModifyApi({ ...params, id: row.id })
    ElMessage.success('修改成功')
    detailsModifyFg.value = false
    detailsFetch(detailsParams)
  })
  MI_modifyForm({ ...row, category }, detailsModifyConfig, detailsModifyFg, async (params: any) => {
    await checkin_balancesModifyApi({...params, id: row.id, ...categoryParams[params.category]})
    ElMessage.success('修改成功')
    detailsModifyFg.value = false
    detailsFetch(detailsParams)
  })
}
// 详情删除
const detailsDelHandle = (row: any) => {
  ElMessageBox.confirm(
    '确定删除？',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      detailsIdentify.value = true
      return checkin_balancesDelApi({ id: row.id })
    })
    .then(() => {
      detailsIdentify.value = false
      ElMessage.success('删除成功')
      detailsHandle(detailsRow)
    })
    .catch(() => {
      detailsIdentify.value = false
    })
}

// 登记
const registerFg = ref<boolean>(false)
const registerConfig = ref([
  {
    label: '备注',
    value: '',
    upKey: 'note',
    props: {}
  },
  {
    type: 'SELECT',
    label: '员工',
    value: [],
    upKey: 'userIds',
    options: fullUserList,
    props: { placeholder: '请选择员工', clearable: true, multiple: true, 'collapse-tags': true },
    rule: [
      { required: true, message: '员工不能为空', trigger: 'change' },
    ],
    seleProps: {
      label: 'label',
      valueName: 'userId',
    }
  },
  {
    label: "小时",
    value: '',
    upKey: 'time',
    rule: [
      { required: true, message: '小时不能为空', trigger: 'change' },
    ],
  },
  {
    type: "TIME",
    label: "时间",
    value: '',
    upKey: 'date',
    rule: [
      { required: true, message: '时间不能为空', trigger: 'change' },
    ],
    props: {
      'value-format': 'YYYY-MM-DD',
      clearable: true,
    }
  },
  {
    type: 'SELECT',
    label: '类别',
    value: '',
    upKey: 'category',
    rule: [
      { required: true, message: '类别不能为空', trigger: 'change' },
    ],
    options: [
      {label: '年假增加', id: 'AnnualIncrease'},
      {label: '年假减少', id: 'AnnualReduce'},
      {label: '加班增加', id: 'OverTimeIncrease'},
      {label: '加班减少', id: 'OverTimeReduce'},
    ],
    props: { placeholder: '请选择类别', clearable: true },
    seleProps: {}
  },
])
const registerHandle = () => {
  MI_modifyForm({}, registerConfig, registerFg, async (params: any) => {
    
    await checkin_balancesApi({...params, ...categoryParams[params.category] })
    ElMessage.success('成功')
    registerFg.value = false
    await fetchData(MI_params)
  })
}

// 上传
const upConfig = ref([
  {
    type: "TIME",
    label: "日期",
    value: dayjs().format('YYYY-MM-DD'),
    upKey: 'date',
    props: {
      'value-format': 'YYYY-MM-DD',
      clearable: false,
      /* 'disabled-date': function(time: any){
        return time.getTime() > Date.now()
      } */
    }
  }
])


// 加班列表
const overTimeSubmitFg = ref<boolean>(false)
const overTimeSubmitConfig = ref([
  {
    type: "TIME",
    label: "时间",
    value: '',
    upKey: 'date',
    props: {
      'value-format': 'YYYY-MM-DD',
      clearable: true,
    }
  },
])
const overTimeConfig = ref([
  {
    label: "姓名",
    value: '',
    upKey: 'key',
  },
  {
    type: "TIME",
    label: "时间",
    value: dayjs().subtract(1, 'month').format('YYYY-MM') + '-01',
    upKey: 'date',
    props: {
      type: 'month',
      'value-format': 'YYYY-MM-DD',
      clearable: true,
    }
  },
])
let overTimeRows: any = ref([])
const { 
  MI_tableData: overData, fetchData: overFetch, page: overPage, size: overSize, MI_params: overParams,
  MI_total: overTotal, MI_pageChange: overPageCg,  MI_identify: overIdentify, MI_sizeChange: overSizeCg
} = new tbMix(overtimeListApi)
const overFg = ref(false)
const overTimeHandle = () => {
  overFg.value = true
  overFetch()
}
const balancesHandle = () => {
  if(overTimeRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  MI_modifyForm({}, overTimeSubmitConfig, overTimeSubmitFg, async (params: any) => {
    await checkin_balancesBatchApi({
      ids: overTimeRows.value.map((user: any) => user.id),
      date: params.date
    })
    overTimeSubmitFg.value = false
    ElMessage.success('延期成功')
    overFetch(overParams)
  })
}


// ------------
const tableRowClassName = ({ row, rowIndex }: { row: any, rowIndex: number }) => {
  if (row.locked === true) {
    return 'gray-row'
  }
  if (row.operate === true) {
    return 'green-row'
  }
  if (row.operate === false) {
    return 'red-row'
  }
  
  return ''
}

const merge = (prop: string, oriArr?: any) => {
  let spanCellArr: any = [];
  let concatCell = 0;
  detailsData.value.map((row, index) => {
    if(index === 0){
      spanCellArr.push(1);
      return ''
    }
    if (row[prop] === detailsData.value[index - 1][prop]) {
      spanCellArr[concatCell] += 1
      spanCellArr.push(0)
    } else {
      spanCellArr.push(1)  
      concatCell = index
    }

    return ''
  })

  // 二次排序
  if(oriArr){
    let stepNum = 0
    return spanCellArr.reduce((arr: number[], _spanCell: number, index: number) => {
      if( _spanCell < oriArr[index]){
        oriArr[ _spanCell + index] = oriArr[index] - _spanCell
        arr.push(_spanCell)
        return arr
      }

      if( _spanCell > oriArr[index]){
        spanCellArr[index + 1] = _spanCell - oriArr[index]
        arr.push(oriArr[index])
        return arr
      }
      // 相等
      arr.push(_spanCell)
      return arr
    }, [])
  }


  return spanCellArr
}

// 对比排序
const dateHeadArr = computed(() => {
  // return merge('date')
  return merge('operate', merge('date'))
})


const objectSpanMethod = ({ row, column, rowIndex, columnIndex }: any) => {

  
  if (columnIndex === 0) {
    
    const _row = dateHeadArr.value[rowIndex]
    // const _row = merge('date')[rowIndex]
    const _col = _row > 0 ? 1 : 0
    return {
      rowspan: _row,
      colspan: _col,
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "假期余额" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (registerHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })), [
        [_directive_permission, void 0, "checkin"]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (overTimeHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })), [
        [_directive_permission, void 0, "checkin"]
      ]),
      _withDirectives(_createVNode(eptBtn, {
        type: "primary",
        exportFn: _unref(templateDownloadApi),
        exportText: '下载年假加班调休假导入模板',
        isDirect: true
      }, null, 8, ["exportFn"]), [
        [_directive_permission, void 0, "checkin"]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_TheUpBtn, {
        class: "ml-10",
        upText: '导入年假加班调休假',
        upFetch: _unref(importCheckin_balancesApi),
        upParams: {},
        upConfig: upConfig.value,
        showBtn: true
      }, {
        tip: _withCtx(() => [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7
        ]),
        _: 1
      }, 8, ["upFetch", "upConfig"])), [
        [_directive_permission, void 0, "checkin"]
      ]),
      _createVNode(_component_el_tooltip, {
        effect: "dark",
        content: "请先搜索后，再导出",
        placement: "top"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(eptBtn, {
            type: "primary",
            exportFn: _unref(exportcheckin_balancesApi),
            exportText: '导出假期余额',
            exportParam: _unref(MI_params)
          }, null, 8, ["exportFn", "exportParam"]), [
            [_directive_permission, void 0, "checkin"]
          ])
        ]),
        _: 1
      }),
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        class: "ml-10",
        type: "danger",
        plain: "",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'holidayDetails' })))
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      })), [
        [_directive_permission, void 0, "checkin"]
      ])
    ]),
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 5 }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              ref: "tb",
              border: "",
              data: _unref(MI_tableData),
              "max-height": _unref(MI_height) - 20 + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "姓名",
                  prop: "realName"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_link, {
                      onClick: ($event: any) => (detailsHandle(row)),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(`${row.realName}(${row.alias})`), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"])), [
              [_directive_loading, _unref(MI_identify)]
            ]),
            _createVNode(_component_el_pagination, {
              small: "",
              total: _unref(MI_total),
              currentPage: _unref(page),
              "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
              "page-size": _unref(size),
              "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
              class: "mb-5 mt-5",
              "page-sizes": [10, 30, 50, 100],
              layout: " pager, jumper",
              onCurrentChange: _unref(MI_pageChange),
              onSizeChange: _unref(MI_sizeChange)
            }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 19 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_descriptions, {
                title: "",
                border: "",
                column: 5
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "姓名" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(detailsRow).realName || '-'), 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(detailsRow).alias || '请选择员工'), 1)
                    ]),
                    _: 1
                  }),
                  (_unref(detailsRow).freedomDisplay)
                    ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                        key: 0,
                        label: "季度自由度剩余额度"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_11, _toDisplayString(((_unref(detailsRow).surplusFreedomLimit || 0) * 8 ).toFixed(1)) + "小时", 1),
                          _createElementVNode("p", null, _toDisplayString(_unref(detailsRow).surplusFreedomLimit || '0') + "天", 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_descriptions_item, { label: "年假剩余" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_12, _toDisplayString(((_unref(detailsRow).annualDay || 0) * 8 ).toFixed(1)) + "小时", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(detailsRow).annualDay || '0') + "天", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "待生效年假额度" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(((_unref(detailsRow).surplusLimit || 0) * 8 ).toFixed(1)) + "小时", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(detailsRow).surplusLimit || '0') + "天", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "当前月调休假待逾期" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(detailsRow).overdueHour || '0') + "小时", 1),
                      _createElementVNode("p", null, _toDisplayString((_unref(detailsRow).overdueHour || 0) / 8) + "天", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "调休假剩余" }, {
                    label: _withCtx(() => [
                      _createVNode(_component_el_popover, {
                        width: 280,
                        placement: "right",
                        trigger: "hover"
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            style: {"font-weight":"700"},
                            link: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_15,
                              _hoisted_16,
                              _hoisted_17
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_form, {
                            class: "time-form",
                            "label-width": "180",
                            "label-position": "left"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "总时长：" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.totalTime : '0') + "小时", 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "日常加班-工作日：" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.dailyWorkTime : '0') + "小时", 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "日常加班-周末：" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.dailyHolidayTime : '0') + "小时", 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "日常加班-法定节假日：" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.dailyFestivalTime : '0') + "小时", 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "项目加班-工作日：" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.projectWorkTime : '0') + "小时", 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "项目加班-周末：" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.projectHolidayTime : '0') + "小时", 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "项目加班-法定节假日：" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.projectFestivalTime : '0') + "小时", 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(detailsRow).adjust?_unref(detailsRow).adjust.totalTime : '0') + "小时", 1),
                      _createElementVNode("p", null, _toDisplayString((_unref(detailsRow).adjust?_unref(detailsRow).adjust.totalTime : 0) / 8) + "天", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_el_tag, {
              class: "mb-10",
              type: "warning",
              style: {"fontSize":"16px"}
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              "span-method": objectSpanMethod,
              border: "",
              data: _unref(detailsData),
              "max-height": 575 + 'px',
              "row-class-name": tableRowClassName
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "日期",
                  prop: "date",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "类型",
                  prop: "category",
                  width: "190"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(row.overtimeNature?_unref(categoryType)[row.category]+'-' + _unref(overtimeNatureType)[row.overtimeNature] :_unref(categoryType)[row.category]) + " ", 1),
                      (row.reimbursementStatus === true)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "小时",
                  prop: "time",
                  width: "80"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(row.operate ? row.time : ('-' + row.time)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作时间",
                  prop: "createdAt",
                  "show-overflow-tooltip": ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(row.createdAt).format('YYYY-MM-DD HH:mm')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作人",
                  prop: "operator",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  label: "更新人",
                  prop: "updatedBy"
                }),
                _createVNode(_component_el_table_column, {
                  label: "更新时间",
                  prop: "updatedAt",
                  "show-overflow-tooltip": ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(row.updatedAt ? _unref(dayjs)(row.updatedAt).format('YYYY-MM-DD HH:mm') : ''), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "事由",
                  prop: "note",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  width: "90"
                }, {
                  default: _withCtx(({ row }) => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      onClick: ($event: any) => (detailsModifyHandle(row)),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, void 0, "checkin"]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, _unref(detailsIdentify)]
            ]),
            _createVNode(_component_el_pagination, {
              small: "",
              background: "",
              total: _unref(detailsTotal),
              currentPage: _unref(detailsPage),
              "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => (_isRef(detailsPage) ? (detailsPage).value = $event : null)),
              "page-size": _unref(detailsSize),
              "onUpdate:page-size": _cache[6] || (_cache[6] = ($event: any) => (_isRef(detailsSize) ? (detailsSize).value = $event : null)),
              class: "mb-5 mt-5",
              "page-sizes": [10, 30, 50,],
              layout: "sizes, prev, pager, next, total, jumper",
              onCurrentChange: _unref(detailsPageCg),
              onSizeChange: _unref(detailsSizeCg)
            }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: detailsModifyFg.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((detailsModifyFg).value = $event)),
      title: "详情修改"
    }, {
      default: _withCtx(() => [
        (detailsModifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _mergeProps({
              key: 0,
              ref: "searchForm"
            }, {
          searchConfig: detailsModifyConfig.value,
          submitText: '确定',
        }), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: overFg.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((overFg).value = $event)),
      width: "85%",
      top: "30px",
      title: "加班列表"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          title: true,
          searchConfig: overTimeConfig.value,
          initSearch: true
        }, {
          onSearchFn: _cache[8] || (_cache[8] = ($event: any) => (_unref(overFetch)($event, {}, 1)))
        }), null, 16),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (balancesHandle()))
          }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          })
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          data: _unref(overData),
          onSelectionChange: _cache[10] || (_cache[10] = (rows) => { _isRef(overTimeRows) //@ts-ignore
 ? overTimeRows.value = rows : overTimeRows = rows }),
          "max-height": 550 + 'px'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              width: "55"
            }),
            _createVNode(_component_el_table_column, {
              label: "姓名",
              prop: "realName",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "日期",
              prop: "date",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "类型",
              prop: "category"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", null, _toDisplayString(row.category === 'Annual' ? '年假' : '加班'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "增加小时",
              prop: ""
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", null, _toDisplayString(row.operate ? row.time : ''), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "事由",
              prop: "note",
              "show-overflow-tooltip": "",
              width: "480"
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(overIdentify)]
        ]),
        _createVNode(_component_el_pagination, {
          small: "",
          background: "",
          total: _unref(overTotal),
          currentPage: _unref(overPage),
          "onUpdate:currentPage": _cache[11] || (_cache[11] = ($event: any) => (_isRef(overPage) ? (overPage).value = $event : null)),
          "page-size": _unref(overSize),
          "onUpdate:page-size": _cache[12] || (_cache[12] = ($event: any) => (_isRef(overSize) ? (overSize).value = $event : null)),
          class: "mb-5 mt-5",
          "page-sizes": [10, 30, 50 ],
          layout: "sizes, prev, pager, next, total, jumper",
          onCurrentChange: _unref(overPageCg),
          onSizeChange: _unref(overSizeCg)
        }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: overTimeSubmitFg.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((overTimeSubmitFg).value = $event)),
      title: "加班日期"
    }, {
      default: _withCtx(() => [
        (overTimeSubmitFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: overTimeSubmitConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "登记",
      modelValue: registerFg.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((registerFg).value = $event))
    }, {
      default: _withCtx(() => [
        (registerFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: registerConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})